export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM ?? "";
export const KEYCLOAK_CLIENT_ID =
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? "";
export const KEYCLOAK_URI = process.env.REACT_APP_KEYCLOAK_URI ?? "";
export const KEYCLOAK_REDIRECT_URI =
  process.env.REACT_APP_KEYCLOAK_REDIRECT_URI;
export const CODE_API_URI = process.env.REACT_APP_CODE_API_URI ?? "";
export const CODE_NOTIFICATION_URI =
  process.env.REACT_APP_NOTIFICATION_API_URI ?? "";
export const META_ID_APP = process.env.REACT_APP_META_ID_APP ?? "";
